import React, { useState } from "react";
import {
  BackGround,
  PaperLogin,
  ButtonLogin,
  DivForm,
  ImagemLogin,
  TextFieldLogin,
  LinkLogin,
  InputsContainer,
  DivText,
  CenterInputs,
  InputsContainerButtons,
} from "../login/styles";
import { useAuthContext } from "../../../contexts/auth-context";
import { Navigate, useNavigate } from "react-router-dom";
import { AiOutlineMail } from "react-icons/ai";
import { InputAdornment } from "@mui/material";
import { useFormik } from "formik";
import AuthService from "../../../services/auth-service";
import * as Yup from "yup";
import Toast from "../../../components/toast";
import ExceptionUtils from "../../../utils/ExceptionUtils";

interface IRecover {
  email: string;
}

const RecuperacaoSenha = () => {
  const { isAuthenticated } = useAuthContext();
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    form.validateForm(form.values).then((errors) => {
      Object.entries(errors).map((error) =>
        Toast.error(error[1])
      );
    });
  };

  const form = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Email: inválido")
        .required("Email: Campo obrigatório"),
    }),
    onSubmit: async (values: IRecover) => {
      try {
        setLoading(true);
        const response = await AuthService.recoverPassword(values.email);
        if (response) {
          Toast.warn("Se uma conta correspondente for encontrada, um e-mail será enviado para permitir que você redefina sua senha.");
        }
      } catch (e) {
        ExceptionUtils.defaultExceptionHandler(e);
      } finally {
        setLoading(false);
      }
    },
    validateOnChange: false,
  });

  if (isAuthenticated) return <Navigate replace to="/dashboard" />;
  return (
    <>
      <BackGround>
        <PaperLogin>
          <ImagemLogin />
          <DivForm onSubmit={form.handleSubmit}>
            <DivText>
              <CenterInputs>
                <InputsContainer>
                  <TextFieldLogin
                    fullWidth
                    label="Email"
                    name={"email"}
                    id={"email"}
                    variant="standard"
                    value={form.values.email}
                    onChange={form.handleChange}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <AiOutlineMail fontSize={25} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </InputsContainer>
              </CenterInputs>
              <InputsContainerButtons>
                <ButtonLogin
                  type={"submit"}
                  onClick={validateForm}
                  disabled={loading}
                >
                  Recuperar Senha
                </ButtonLogin>
                <LinkLogin onClick={() => navigate("/login")}>Voltar</LinkLogin>
              </InputsContainerButtons>
            </DivText>
          </DivForm>
        </PaperLogin>
      </BackGround>
    </>
  );
};

export default RecuperacaoSenha;
